import { slices } from "@/constants/sliceNames";
import {
  requestDeleteUserStatus,
  requestSingleUserStatus,
  requestUsersListStatus,
  requestUpdateUserStatus,
  requestUserExecutionsStatsStatus,
  requestUserStatsDatasetStatus,
} from "@/store/effects/admin-dashboard/users-effects";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  records_count: 0,
  loading: false,
  error: null,
  item: {},
  executionLoading: false,
  datasetLoading: false,
  statistics: {
    datasets: [],
    resources: [],
    userExecs: {},
  },
};

const usersSlice = createSlice({
  name: slices.users,
  initialState,
  extraReducers: {
    ...requestUsersListStatus,
    ...requestDeleteUserStatus,
    ...requestSingleUserStatus,
    ...requestUpdateUserStatus,
    ...requestUserExecutionsStatsStatus,
    ...requestUserStatsDatasetStatus,
  },
});

const { actions, reducer } = usersSlice;

export { actions, initialState };

export default reducer;
